import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ChatInterface } from "@/components/chat/ChatInterface";

export default function Chat() {
  const navigate = useNavigate();

  return (
    <div className="h-[100dvh] flex flex-col bg-background">
      {/* Header Bar */}
      <header className="flex-shrink-0 flex items-center justify-between px-4 py-3 border-b border-border bg-background/95 backdrop-blur-sm">
        <button
          onClick={() => navigate(-1)}
          className="p-2 -ml-2 rounded-full hover:bg-muted transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="h-5 w-5 text-foreground" />
        </button>
        
        <span className="font-display text-lg font-semibold text-primary">
          PixieClicks
        </span>
        
        {/* Spacer for centering */}
        <div className="w-9" />
      </header>

      {/* Chat Interface - directly fills remaining space */}
      <ChatInterface onClose={() => navigate(-1)} />
    </div>
  );
}
